import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";
import { PushNotificationsService } from "ng-push-ivy";
import { ToastrService } from "ngx-toastr";
import { ChatService } from "src/app/Chat.service";
import { HttpmethodsService } from "src/app/demo/service/httpmethods.service";
import {
  admissionMasterUrl,
  leadFollowupUrl,
  leadTransferUrl,
} from "src/app/demo/ui-elements/ui-basic/modelurl";
declare var $: any;
@Component({
  selector: "app-nav-right",
  templateUrl: "./nav-right.component.html",
  styleUrls: ["./nav-right.component.scss"],
  providers: [NgbDropdownConfig],
})
export class NavRightComponent implements OnInit {
  privilegeData: any;

  constructor(
    private _pushNotifications: PushNotificationsService,
    private router: Router,
    private toastr: ToastrService,
    private chatService: ChatService,
    private httpService: HttpmethodsService
  ) {
    this._pushNotifications.requestPermission();
    this.privilegeData = JSON.parse(localStorage.getItem("privilegeData"));
  }

  ngOnInit() {
    $("#todayPendingCallCount").text(0);
    $("#pendingCallCount").text(0);
    $("#transferLeadCount").text(0);
    $("#pendingFeesReminderCount").text(0);
    $("#dailyFeesReminderCount").text(0);
    this.getTodayPendingCallList();
    this.getPendingCallList();
    this.getTransferLeadList();
    this.getPendingFeesList();
    this.getTodayPendingFeesList();
    let staffId = localStorage.getItem("staffId");
    this.chatService.getMessages(staffId).subscribe((message: any) => {
      this.toastr.info(message, "Lead Followup Reminder", {
        timeOut: 60000,
      });
    });
  }
  showTransferLeadList() {
    this.router.navigateByUrl("/basic/leadtransfershow");
  }
  showTodayPendingCallList() {
    this.router.navigateByUrl("/basic/todaypendinglead");
  }

  showPendingCallList() {
    this.router.navigateByUrl("/basic/pendinglead");
  }

  logOut() {
    localStorage.clear();
    sessionStorage.clear();
    this.toastr.success("Logout", "SUCCESS");
    this.router.navigateByUrl("");
  }

  getTodayPendingCallList() {
    let staffId;
    if (JSON.parse(this.privilegeData.leadDisplyShowWithoutAdmin)) {
      staffId = 0;
    } else {
      staffId = localStorage.getItem("staffId");
    }
    let branchId = localStorage.getItem("branchId");
    var paginationObj = {
      pageIndex: 0,
      pageSize: 25,
      branchId: branchId,
      staffId: staffId,
    };
    this.httpService
      .postRequest(leadFollowupUrl + "/getTodayPendingCallList", paginationObj)
      .subscribe(
        (result: any) => {
          $("#todayPendingCallCount").text(result.totalItems);
        },
        (error) => {}
      );
  }

  getPendingCallList() {
    let staffId;
    if (JSON.parse(this.privilegeData.leadDisplyShowWithoutAdmin)) {
      staffId = 0;
    } else {
      staffId = localStorage.getItem("staffId");
    }
    let branchId = localStorage.getItem("branchId");
    var paginationObj = {
      pageIndex: 0,
      pageSize: 25,
      branchId: branchId,
      staffId: staffId,
    };
    this.httpService
      .postRequest(leadFollowupUrl + "/getPendingCallList", paginationObj)
      .subscribe(
        (result: any) => {
          $("#pendingCallCount").text(result.totalItems);
        },
        (error) => {}
      );
  }

  getTodayPendingFeesList() {
    let staffId;
    if (JSON.parse(this.privilegeData.admissionDisplyShowWithoutAdmin)) {
      staffId = 0;
    } else {
      staffId = localStorage.getItem("staffId");
    }
    let branchId = localStorage.getItem("branchId");
    var paginationObj = {
      pageIndex: 0,
      pageSize: 25,
      branchId: branchId,
      staffId: staffId,
    };
    this.httpService
      .postRequest(
        admissionMasterUrl + "/getTodayPendingPaymentCallList",
        paginationObj
      )
      .subscribe(
        (result: any) => {
          $("#pendingFeesReminderCount").text(result.totalItems);
        },
        (error) => {}
      );
  }

  getPendingFeesList() {
    let staffId;
    if (JSON.parse(this.privilegeData.admissionDisplyShowWithoutAdmin)) {
      staffId = 0;
    } else {
      staffId = localStorage.getItem("staffId");
    }
    let branchId = localStorage.getItem("branchId");
    var paginationObj = {
      pageIndex: 0,
      pageSize: 25,
      branchId: branchId,
      staffId: staffId,
    };
    this.httpService
      .postRequest(
        admissionMasterUrl + "/getPendingPaymentCallList",
        paginationObj
      )
      .subscribe(
        (result: any) => {
          $("#dailyFeesReminderCount").text(result.totalItems);
        },
        (error) => {}
      );
  }

  getTransferLeadList() {
    let staffId = localStorage.getItem("staffId");
    let branchId = localStorage.getItem("branchId");
    var paginationObj = {
      pageIndex: 0,
      pageSize: 25,
      branchId: branchId,
      staffId: staffId,
    };
    this.httpService
      .postRequest(leadTransferUrl + "/getTransferLeadList", paginationObj)
      .subscribe(
        (result: any) => {
          $("#transferLeadCount").text(result.totalItems);
        },
        (error) => {}
      );
  }

  pendingPaymentReminderList() {
    this.router.navigateByUrl("/basic/pendingpaymentreminder");
  }
  dailyPaymentReminderList() {
    this.router.navigateByUrl("/basic/dailypaymentreminder");
  }
}
